export const DOWNLOAD_REPORT_BUTTON_ID = 'download-report-buttons';
